import React, { useState, useEffect } from 'react';

const DigitalClock = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (time) => {
        return time.toISOString().substr(11, 8);
    };

    return (
        <div>
            <time>{formatTime(time)}</time>
        </div>
    );
};

export default DigitalClock;
